import { RestService } from "./RestService";

export class CustomerService extends RestService {
  constructor() {
    super("/api/v1/customers");
  }
}
